// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3040":"d1210bef","5151":"d3a164e1","9536":"ed424183","9753":"4e5d8866","9887":"2fc81982"}[chunkId] + ".chunk.css";
};